<template>
  <div>
    <nav class="breadcrumb is-small" aria-label="breadcrumbs">
      <ul>
        <li>
          <router-link to="/companies">
            一覧
          </router-link>
        </li>
        <li class="is-active">
          <a href="#" aria-current="page">会社詳細</a>
        </li>
      </ul>
    </nav>
    <h2 class="title is-4">
      {{ company.company_name }} 詳細ページ
    </h2>
    <div class="field">
      <router-link v-if="company_id" class="button is-primary"
                   :to="{ name: 'CompaniesRegister', params: { company_id: company_id }}"
      >
        <!-- Edit -->
        編集
      </router-link>
    </div>
    <div class="columns">
      <div class="column is-narrow">
        <table class="table is-bordered">
          <tr>
            <!-- Construction owner name -->
            <th>施工主名</th>
            <td>{{ company.company_name }}</td>
          </tr>
          <tr>
            <!-- Construction owner Furigana -->
            <th>施工主名ふりがな</th>
            <td>{{ company.company_name_kana }}</td>
          </tr>
          <tr>
            <!-- Trader name -->
            <th>業者名</th>
            <td>{{ company.advertising_agency }}</td>
          </tr>
          <tr>
            <!-- Structure type (1) -->
            <th>構造種別（1）</th>
            <td>{{ company.industry_type }}</td>
          </tr>
          <tr>
            <!-- Structure type (2) -->
            <th>構造種別（2）</th>
            <td>
              <b-taglist>
                <b-tag v-for="(row, key) in tags" :key="key" type="is-success">
                  {{ row.tagName }}
                </b-tag>
              </b-taglist>
            </td>
          </tr>
          <tr>
            <th>URL</th>
            <td><a :href="company.url" target="_blank">{{ company.url }}</a></td>
          </tr>
          <tr>
            <th>登録社員</th>
            <td>{{ company.employee_name }}</td>
          </tr>
          <tr>
            <th>備考</th>
            <td id="company-note">
              {{ company.note }}
            </td>
          </tr>
        </table>
      </div>

      <div class="column is-narrow">
        <table v-for="shop in shops" :key="shop.shop_id" class="table is-bordered max-width">
          <tr>
            <!-- <th>店舗名</th>
            <td>{{ shop.shop_name }}</td> -->
            <th>担当者</th>
            <td class="space-nowrap">
              {{ shop.charge }}<span v-if="shop.charge_kana">（{{ shop.charge_kana }}）</span>
            </td>
          </tr>
          <!-- <tr>
            <th>店舗名ふりがな</th>
            <td>{{ shop.shop_name_kana }}</td>
          </tr> -->
          <tr>
            <th>電話番号</th>
            <td class="space-nowrap">
              <p v-for="row in shop.phone_numbers" :key="row.phone_number">
                {{ row.phone_number | tel }}
              </p>
            </td>
          </tr>
          <tr>
            <th>住所</th>
            <td>
              {{ shop.address }}
            </td>
          </tr>
          <tr>
            <th>状態</th>
            <td class="space-nowrap">
              {{ states[shop.state] }}
            </td>
          </tr>
          <tr>
            <th>メールアドレス</th>
            <td><a :href="`mailto:${shop.email_address}`">{{ shop.email_address }}</a></td>
          </tr>
          <tr>
            <th>見込み</th>
            <td>{{ likelihoods[shop.likelihood] }}</td>
          </tr>
        </table>
      </div>
    </div>

    <h2 class="title is-5">
      通話履歴
    </h2>
    <div class="field">
      <router-link class="button is-primary"
                   :to="{ name: 'CallHistoriesRegister', params: { call_id: 'new', company_id: company_id }}"
      >
        通話履歴
        新規登録
      </router-link>
    </div>
    <div class="columns">
      <div class="column is-narrow">
        <div class="control">
          <div class="select">
            <select v-model="queryShop" title="">
              <option :value="null">
                すべて表示
              </option>
              <option v-for="shop in renderShops" :key="shop.shop_id" :value="shop.shop_id">
                {{ shop.shop_name }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="field">
      <p>全{{ renderCallHistory.length }}件</p>
    </div>

    <b-table
      :data="renderCallHistory.length < 1 ? [] :renderCallHistory"
      :striped="isStriped"
    >
      <b-table-column v-slot="props" label="日時">
        {{ props.row.call_dt | toFormattedDatetime }}
      </b-table-column>
      <!-- <b-table-column v-slot="props" label="店舗">
        {{ props.row.shop_name }}
      </b-table-column> -->
      <b-table-column v-slot="props" label="電話番号">
        {{ props.row.phone_number }}
      </b-table-column>
      <b-table-column v-slot="props" label="担当社員">
        {{ props.row.employee_name }}
      </b-table-column>
      <b-table-column v-slot="props" cell-class="call_content" label="電話内容">
        <div @click="showModal(props.row.call_dt, props.row.employee_name, props.row.call_content)">
          {{ props.row.call_content | truncate(10) }}
        </div>
      </b-table-column>
      <b-table-column v-slot="props" label="状態">
        {{ states[props.row.state] }}
      </b-table-column>
      <b-table-column v-slot="props" label="見込み">
        {{ shortLikelihoods[props.row.likelihood] }}
      </b-table-column>
      <b-table-column v-slot="props" label="">
        <router-link class="button is-primary is-outlined"
                     :to="{ name: 'CallHistoriesRegister', params: { call_id: props.row.call_id }}"
        >
          編集
        </router-link>
      </b-table-column>
      <b-table-column v-slot="props" label="">
        <button class="button is-danger is-outlined"
                @click="showDeleteModal(props.row.call_id, props.row.call_dt, props.row.employee_name)"
        >
          削除
        </button>
      </b-table-column>
    </b-table>
    <b-modal :active.sync="isComponentModalActive" has-modal-card>
      <modal-form v-bind="formProps" />
    </b-modal>
    <b-modal :active.sync="isDeleteModalActive" has-modal-card>
      <delete-modal v-bind="formProps" @delete="deleteCallHistory(formProps.call_id)" />
    </b-modal>
  </div>
</template>

<script>
const modalForm = {
  inheritAttrs: false,
  props: [
    'call_dt',
    'employee_name',
    'call_content',
  ],
  template: `
    <div class="modal-card" style="width: auto">
    <header class="modal-card-head">
      <p class="modal-card-title">{{ call_dt | toFormattedDatetime }} / {{ employee_name }}</p>
    </header>
    <section class="modal-card-body">
      <div style="white-space: pre-wrap;">{{ call_content }}</div>
    </section>
    <footer class="modal-card-foot">
      <button class="button" type="button" @click="$parent.close()">閉じる</button>
    </footer>
    </div>
  `,
}
const deleteModal = {
  inheritAttrs: false,
  props: [
    'call_dt',
    'employee_name',
  ],
  template: `
    <div class="modal-card" style="width: auto">
    <header class="modal-card-head">
      <p class="modal-card-title">削除確認：{{ call_dt | toFormattedDatetime }} / {{ employee_name }}</p>
    </header>
    <section class="modal-card-body">
      <div style="white-space: pre-wrap;">{{ call_dt | toFormattedDatetime }} / {{ employee_name }}を削除しますか？<br>この操作は取り消せません
      </div>
    </section>
    <footer class="modal-card-foot">
      <button class="button is-danger" type="button" v-on:click="doDeleteCallHistory()">削除</button>
      <button class="button" type="button" @click="$parent.close()">閉じる</button>
    </footer>
    </div>
  `,
  methods: {
    doDeleteCallHistory() {
      this.$emit('delete')
    },
  },
}

export default {
  name: 'CompaniesDetail',
  components: {
    ModalForm: modalForm,
    'delete-modal': deleteModal,
  },
  data() {
    return {
      company_id: null,
      company: [],
      shops: [],
      tags: [],
      phone_numbers: [],
      call_histories: [],
      states: [],
      likelihoods: [],
      shortLikelihoods: [],
      isComponentModalActive: false,
      isDeleteModalActive: false,
      formProps: {
        call_id: null,
        call_dt: null,
        employee_name: null,
        call_content: null,
      },
      queryShop: null,
      count: 0,
      empty_flag: 0,
      isStriped: true,

    }
  },
  computed: {
    renderShops() {
      return this.shops
    },
    renderCallHistory() {
      // 検索処理も含む
      let call_histories = this.call_histories
      if (this.queryShop) {
        let shop_id = this.queryShop
        call_histories = call_histories.filter(row => {
          return ['shop_id'].some(function (key) {
            return Number(row[key]) === Number(shop_id)
          })
        })
      }
      return call_histories
    },
  },
  watch: {
    '$route'() {
      this.getDetail()
    },
  },
  created() {
    this.getDetail()
  },
  methods: {
    getDetail() {
      this.company_id = Number(this.$route.params.company_id)
      this.$http.get('/companies/' + this.company_id + '/detail').then(response => {
        this.company = response.data.company
        this.tags = response.data.tags
        this.shops = response.data.shops
        let phone_numbers = response.data.phone_numbers
        this.call_histories = response.data.call_histories
        this.states = response.data.states
        this.likelihoods = response.data.likelihoods
        this.shortLikelihoods = response.data.shortLikelihoods
        this.shops.forEach((row) => {
          row.phone_numbers = phone_numbers[row.shop_id]
        })
      })
    },
    showModal(call_dt, employee_name, call_content) {
      this.formProps.call_dt = call_dt
      this.formProps.employee_name = employee_name
      this.formProps.call_content = call_content
      this.isComponentModalActive = true
    },
    showDeleteModal(call_id, call_dt, employee_name) {
      this.formProps.call_id = call_id
      this.formProps.call_dt = call_dt
      this.formProps.employee_name = employee_name
      this.isDeleteModalActive = true
    },
    deleteCallHistory(call_id) {
      this.openLoading()
      this.$http.post('/call-histories/' + call_id + '/delete').then(() => {
        this.getDetail()
        this.closeLoading()
        this.$buefy.toast.open(`削除が完了しました`)
      }).catch(error => {
        console.log(error)
        this.closeLoading()
      })
      this.isDeleteModalActive = false
    },
  },
}
</script>

<style>
.call_content {
  cursor: pointer;
}

#company-note {
  max-width: 400px;
  white-space: pre-wrap;
}

  .max-width {
    max-width: 1200px;
  }

  .max-width .space-nowrap{
    white-space: nowrap;
  }
</style>
